module.exports = __webpack_public_path__ + "static/media/44563141_2199900626751783_6290134687671123968_o-thumb.6ed2f50e.jpg";